module.exports = __webpack_public_path__ + "img/logo2.8b0e34b0.png";